import { render, staticRenderFns } from "./VideosDatosNovedadForm.vue?vue&type=template&id=77907fe6&scoped=true"
import script from "./VideosDatosNovedadForm.vue?vue&type=script&lang=ts"
export * from "./VideosDatosNovedadForm.vue?vue&type=script&lang=ts"
import style0 from "./VideosDatosNovedadForm.vue?vue&type=style&index=0&id=77907fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77907fe6",
  null
  
)

export default component.exports